import {
  type ExtendedGridColumnHeaderProps,
  ContainerPopper,
  ExtendedAutocomplete,
  FakeDropdownBox,
  useDataGridContext,
  useMultipleSelectorProps,
} from '@issuemanager/apps/client/components';
import { Stack, useEventCallback } from '@mui/material';
import { useState } from 'react';
import {
  IssueSourceApplicationData,
  useIssueSourceApplications,
} from '../issue-source-app';

export function IssueGridSourceApplicationFilter(
  params: ExtendedGridColumnHeaderProps,
) {
  const options = useIssueSourceApplications();
  const context = useDataGridContext();
  const value: IssueSourceApplicationData[] =
    context.filterModel[params.field] ?? [];

  const [partialValue, setPartialValue] = useState(value ?? []);

  const handleChange = useEventCallback((value) => {
    context.setFilterModel((prevState) => ({
      ...prevState,
      [params.field]: value,
    }));
  });

  const autocompleteProps = useMultipleSelectorProps({
    options,
    value,
    setValue: handleChange,
    partialValue,
    setPartialValue,
  });

  const handleClose = useEventCallback((onClose: () => void) => {
    setPartialValue(value);
    onClose();
  });

  return (
    <ContainerPopper
      renderTarget={(props) => (
        <FakeDropdownBox onClick={props.handleClick}>
          {value.length ? (
            <Stack direction='row' spacing={0.5}>
              {value.map((v) => v.label).join(', ')}
            </Stack>
          ) : null}
        </FakeDropdownBox>
      )}
      renderChildren={(props) => (
        <ExtendedAutocomplete
          {...autocompleteProps}
          open
          options={options}
          getOptionLabel={(option) => option.label}
          isOptionEqualToValue={(option, value) => option.value === value.value}
          renderOption={(_, option) => option.label}
          onClose={() => handleClose(props.handleClose)}
          TextFieldProps={{
            autoFocus: true,
          }}
        />
      )}
      onClickOutside={() => setPartialValue(value)}
    />
  );
}
